(function () {
  const SELECTORS = {
    modal: 'free-gift-modal',
    close: '[data-free-gift-close]',
    item: '[data-free-gift-item]',
    variant: '[data-free-gift-variant]',
    pick: '[data-free-gift-pick]',
    claim: '[data-free-gift-claim]',
    progress: '[data-free-gift-progress]',
    progressMessage: '[data-free-gift-progress-message]',
    progressMobileMessage: '[data-free-gift-progress-mobile-message]',
    progressToggle: '[data-free-gift-progress-toggle]',
    progressToggleIcon: '[data-free-gift-progress-toggle-icon]',
    progressClaim: '[data-free-gift-progress-claim]',
    progressCheck: '[data-free-gift-progress-check]',
    progressTrack: '[data-free-gift-progress-track]',
    progressFill: '[data-free-gift-progress-fill]',
    progressGoal: '[data-free-gift-progress-goal]',
    productProgress: '[data-free-gift-progress][data-placement="product"]',
    cartForm: 'form[action*="/cart/add"]',
    shtCartDrawer: 'sht-cart-drwr',
    shtCartDrawerForm: 'sht-cart-drwr-frm',
    shtCartNotification: 'sht-cart-noti'
  };

  const CART_ENDPOINTS = ['/cart/add', '/cart/change', '/cart/update', '/cart/clear'];
  const CHECK_DELAY = 350;
  const PROPERTY_NAME = '_free_gift';
  const PROPERTY_VALUE = 'true';

  const modal = document.querySelector(SELECTORS.modal);
  if (!modal) return;

  let isChecking = false;
  let isMutatingGift = false;
  let selectedVariantId = null;
  let checkTimer = null;
  let lastProgressPercent = null;
  let lastKnownCart = null;

  const threshold = Number(modal.dataset.threshold || 0);
  const pickLabel = modal.dataset.pickLabel || 'Pick';
  const pickedLabel = modal.dataset.pickedLabel || 'Picked';
  const giftProducts = parseJsonAttribute(modal.dataset.giftProducts, []);
  const giftVariantIds = giftProducts.flatMap((product) => {
    return (product.variants || []).map((variant) => Number(variant.id));
  });

  if (!threshold || !giftVariantIds.length) return;

  function getCurrencyRate() {
    const rate = window.Shopify &&
      window.Shopify.currency &&
      window.Shopify.currency.rate;

    const parsedRate = Number(rate);
    return Number.isFinite(parsedRate) && parsedRate > 0 ? parsedRate : 1;
  }

  function getActiveThreshold() {
    return Math.round(threshold * getCurrencyRate());
  }

  function parseJsonAttribute(value, fallback) {
    if (!value) return fallback;

    try {
      const textarea = document.createElement('textarea');
      textarea.innerHTML = value;
      return JSON.parse(textarea.value);
    } catch (error) {
      console.warn('[free-gift] Could not parse gift products JSON.', error);
      return fallback;
    }
  }

  function getRootUrl() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }

    return '/';
  }

  function buildCartUrl(path) {
    return getRootUrl() + path.replace(/^\//, '');
  }

  async function fetchJson(url, options) {
    const response = await fetch(url, options);

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.description || error.message || response.statusText);
    }

    return response.json();
  }

  function getCart() {
    return fetchJson(buildCartUrl('cart.js'));
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }

    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD'
      }).format(cents / 100);
    } catch (error) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function isGiftLine(item) {
    return giftVariantIds.includes(Number(item.variant_id));
  }

  function eligibleSubtotal(cart) {
    return cart.items
      .filter((item) => !isGiftLine(item))
      .reduce((total, item) => total + Number(item.final_line_price || 0), 0);
  }

  function giftLines(cart) {
    return cart.items.filter(isGiftLine);
  }

  function hasGift(cart) {
    return giftLines(cart).length > 0;
  }

  function interpolateMessage(template, values) {
    return Object.keys(values).reduce((message, key) => {
      return message.replace(new RegExp('{{\\s*' + key + '\\s*}}', 'g'), values[key]);
    }, template || '');
  }

  function updateText(element, text) {
    if (element && element.textContent !== text) {
      element.textContent = text;
    }
  }

  function captureCurrentProgressPercent() {
    const fill = document.querySelector(SELECTORS.progressFill);
    if (!fill) return;

    const track = fill.closest(SELECTORS.progressTrack);
    const width = parseFloat(fill.style.width || (track && track.getAttribute('aria-valuenow')));
    if (!Number.isNaN(width)) {
      lastProgressPercent = width;
    }
  }

  function applyAnimatedProgressWidth(fill, percent) {
    const targetPercent = Math.max(0, Math.min(percent, 100));

    if (
      lastProgressPercent !== null &&
      lastProgressPercent !== targetPercent &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      fill.style.transition = 'none';
      fill.style.width = lastProgressPercent + '%';
      fill.offsetWidth;

      window.requestAnimationFrame(() => {
        fill.style.transition = '';
        fill.style.width = targetPercent + '%';
      });
    } else {
      fill.style.width = targetPercent + '%';
    }
  }

  function animateRenderedProgressBars(root) {
    if (lastProgressPercent === null || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    const scope = root && root.querySelectorAll ? root : document;
    const fills = [];

    if (scope.matches && scope.matches(SELECTORS.progressFill)) {
      fills.push(scope);
    }

    fills.push(...scope.querySelectorAll(SELECTORS.progressFill));

    let animatedTargetPercent = null;

    fills.forEach((fill) => {
      const track = fill.closest(SELECTORS.progressTrack);
      const targetPercent = parseFloat(fill.style.width || (track && track.getAttribute('aria-valuenow')));

      if (Number.isNaN(targetPercent) || targetPercent === lastProgressPercent) return;

      applyAnimatedProgressWidth(fill, targetPercent);
      animatedTargetPercent = targetPercent;
    });

    if (animatedTargetPercent !== null) {
      lastProgressPercent = animatedTargetPercent;
    }
  }

  function updateProgressBars(cart) {
    const progressBars = document.querySelectorAll(SELECTORS.progress);
    if (!progressBars.length || !cart) return;

    lastKnownCart = cart;

    const activeThreshold = getActiveThreshold();
    const subtotal = eligibleSubtotal(cart);
    const remaining = Math.max(activeThreshold - subtotal, 0);
    const percent = activeThreshold > 0 ? Math.min(Math.round((subtotal / activeThreshold) * 100), 100) : 0;
    const unlocked = remaining === 0;
    const cartHasGift = hasGift(cart);

    progressBars.forEach((progress) => {
      const message = progress.querySelector(SELECTORS.progressMessage);
      const mobileMessage = progress.querySelector(SELECTORS.progressMobileMessage);
      const claim = progress.querySelector(SELECTORS.progressClaim);
      const check = progress.querySelector(SELECTORS.progressCheck);
      const track = progress.querySelector(SELECTORS.progressTrack);
      const fill = progress.querySelector(SELECTORS.progressFill);
      const goal = progress.querySelector(SELECTORS.progressGoal);
      const remainingTemplate = progress.dataset.remainingMessage || '{{ amount }} left for the GIFT!';
      const remainingTemplateMobile = progress.dataset.remainingMessageMobile || 'Spend {{ amount }} and claim free name tag';
      const unlockedTemplate = progress.dataset.unlockedMessage || 'You unlocked a Free Nametag';
      const claimLabel = progress.dataset.claimLabel || 'Claim.';

      progress.hidden = false;
      progress.classList.toggle('is-unlocked', unlocked);
      progress.classList.toggle('has-gift', cartHasGift);

      const progressText = unlocked
        ? interpolateMessage(unlockedTemplate, {
            amount: formatMoney(remaining),
            threshold: formatMoney(activeThreshold),
            total: formatMoney(subtotal)
          })
        : interpolateMessage(remainingTemplate, {
            amount: formatMoney(remaining),
            threshold: formatMoney(activeThreshold),
            total: formatMoney(subtotal)
      });

      const progressTextMobile = unlocked
        ? interpolateMessage(unlockedTemplate, {
            amount: formatMoney(remaining),
            threshold: formatMoney(activeThreshold),
            total: formatMoney(subtotal)
          })
        : interpolateMessage(remainingTemplateMobile, {
            amount: formatMoney(remaining),
            threshold: formatMoney(activeThreshold),
            total: formatMoney(subtotal)
      });

      if (message) {
        updateText(message, progressText);
      }

      if (mobileMessage) {
        updateText(mobileMessage, progressTextMobile);
      }

      if (claim) {
        updateText(claim, claimLabel);
        claim.hidden = !unlocked || cartHasGift;
      }

      if (check) {
        check.hidden = !unlocked;
      }

      if (track) {
        track.setAttribute('aria-valuenow', String(percent));
      }

      if (fill) {
        applyAnimatedProgressWidth(fill, percent);
      }

      if (goal) {
        updateText(goal, formatMoney(activeThreshold));
      }

      progress.dataset.freeGiftNormalized = 'true';
    });

    lastProgressPercent = percent;
    updateProductProgressOffset();
  }

  function updateProductProgressOffset() {
    const productProgressBars = Array.from(document.querySelectorAll(SELECTORS.productProgress));
    if (!productProgressBars.length) return;

    const visibleHeight = productProgressBars.reduce((height, productProgress) => {
      const rect = productProgress.getBoundingClientRect();
      const styles = window.getComputedStyle(productProgress);
      const isVisible = styles.display !== 'none' && styles.visibility !== 'hidden' && rect.height > 0;

      return isVisible ? Math.max(height, Math.ceil(rect.height)) : height;
    }, 0);

    if (!visibleHeight) return;

    document.documentElement.style.setProperty('--free-gift-product-progress-offset', visibleHeight + 32 + 'px');
    document.body.classList.add('has-free-gift-product-progress');
  }

  function toggleProductProgress(progress) {
    if (!progress || progress.dataset.placement !== 'product') return;

    const isOpen = !progress.classList.contains('is-mobile-open');
    const toggle = progress.querySelector(SELECTORS.progressToggle);
    const icon = progress.querySelector(SELECTORS.progressToggleIcon);

    progress.classList.toggle('is-mobile-open', isOpen);

    if (toggle) {
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }

    if (icon) {
      icon.textContent = isOpen ? '-' : '+';
    }

    updateProductProgressOffset();
  }

  function openModal() {
    if (modal.hidden) {
      resetGiftSelection();
    }

    modal.hidden = false;
    document.documentElement.classList.add('free-gift-modal-open');

    const firstPickButton = modal.querySelector(SELECTORS.pick);
    if (firstPickButton) firstPickButton.focus({ preventScroll: true });
  }

  function closeModal() {
    modal.hidden = true;
    document.documentElement.classList.remove('free-gift-modal-open');
  }

  function getClaimButton() {
    return modal.querySelector(SELECTORS.claim);
  }

  function resetGiftSelection() {
    selectedVariantId = null;

    modal.querySelectorAll(SELECTORS.item).forEach((item) => {
      item.classList.remove('is-selected');
      item.removeAttribute('aria-selected');

      const pickButton = item.querySelector(SELECTORS.pick);
      if (pickButton) {
        pickButton.classList.remove('is-picked');
        pickButton.setAttribute('aria-pressed', 'false');
        pickButton.textContent = pickLabel;
      }
    });

    const claimButton = getClaimButton();
    if (claimButton) {
      claimButton.disabled = true;
    }
  }

  function selectGiftItem(item) {
    if (!item) return;

    const variantInput = item.querySelector(SELECTORS.variant);
    if (!variantInput || !variantInput.value) return;

    selectedVariantId = variantInput.value;

    modal.querySelectorAll(SELECTORS.item).forEach((giftItem) => {
      const isSelected = giftItem === item;
      giftItem.classList.toggle('is-selected', isSelected);
      giftItem.setAttribute('aria-selected', isSelected ? 'true' : 'false');

      const pickButton = giftItem.querySelector(SELECTORS.pick);
      if (pickButton) {
        pickButton.classList.toggle('is-picked', isSelected);
        pickButton.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        pickButton.textContent = isSelected ? pickedLabel : pickLabel;
      }
    });

    const claimButton = getClaimButton();
    if (claimButton) {
      claimButton.disabled = false;
    }
  }

  async function changeLine(key, quantity, includeSections) {
    const body = {
      id: key,
      quantity
    };
    const sections = includeSections ? getThemeSectionsToRender() : [];

    if (sections.length) {
      body.sections = sections;
      body.sections_url = window.location.pathname;
    }

    return fetchJson(buildCartUrl('cart/change.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(body)
    });
  }

  async function removeAllGifts(cart) {
    const gifts = giftLines(cart);
    if (!gifts.length) return cart;

    let updatedCart = cart;
    for (const item of gifts) {
      updatedCart = await changeLine(item.key, 0, true);
    }

    return updatedCart;
  }

  async function enforceSingleGift(cart) {
    const gifts = giftLines(cart);
    if (!gifts.length) return cart;

    let updatedCart = cart;
    let keptGift = false;

    for (const item of gifts) {
      if (!keptGift) {
        keptGift = true;

        if (item.quantity > 1) {
          updatedCart = await changeLine(item.key, 1);
        }
      } else {
        updatedCart = await changeLine(item.key, 0);
      }
    }

    return updatedCart;
  }

  function getThemeSectionsToRender() {
    const cartDrawer = document.querySelector(SELECTORS.shtCartDrawer);
    const cartNotification = document.querySelector(SELECTORS.shtCartNotification);
    const sections = [];

    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      sections.push(...cartDrawer.getSectionsToRender());
    }

    if (cartNotification && typeof cartNotification.getSectionsToRender === 'function') {
      sections.push(...cartNotification.getSectionsToRender());
    }

    const sectionIds = sections
      .map((section) => section && section.section)
      .filter(Boolean);

    return Array.from(new Set(sectionIds));
  }

  function openThemeCartDrawer() {
    const cartDrawer = document.querySelector(SELECTORS.shtCartDrawer);
    if (!cartDrawer) return;

    ['open', 'show', 'showDrawer', 'openDrawer'].some((methodName) => {
      if (typeof cartDrawer[methodName] === 'function') {
        cartDrawer[methodName]();
        return true;
      }

      return false;
    });
  }

  function renderThemeCart(sectionResponse, cart, options) {
    if (!sectionResponse || !sectionResponse.sections) return;

    const renderOptions = {
      openDrawer: true,
      ...(options || {})
    };
    const cartDrawerForm = document.querySelector(SELECTORS.shtCartDrawerForm);
    const cartDrawer = document.querySelector(SELECTORS.shtCartDrawer);
    const cartNotification = document.querySelector(SELECTORS.shtCartNotification);
    const renderedState = {
      ...cart,
      sections: sectionResponse.sections
    };

    if (cartDrawerForm && typeof cartDrawerForm.renderContents === 'function') {
      cartDrawerForm.renderContents(renderedState);
    } else if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
      cartDrawer.renderContents(renderedState);
    }

    if (cartNotification && typeof cartNotification.getSectionsToRender === 'function') {
      cartNotification.getSectionsToRender().forEach((section) => {
        const target = section.space_selector && document.querySelector(section.space_selector);

        if (
          section.id === 'header-cart-status' &&
          target &&
          typeof cartNotification.getSectionInnerHTML === 'function' &&
          sectionResponse.sections[section.id]
        ) {
          target.innerHTML = cartNotification.getSectionInnerHTML(
            sectionResponse.sections[section.id],
            section.selector
          );
        }
      });
    }

    if (renderOptions.openDrawer) {
      openThemeCartDrawer();
    }
  }

  async function addGift(variantId) {
    if (!variantId || isMutatingGift) return;

    isMutatingGift = true;
    modal.classList.add('is-loading');

    try {
      let cart = await getCart();
      cart = await enforceSingleGift(cart);

      if (eligibleSubtotal(cart) < getActiveThreshold() || hasGift(cart)) {
        closeModal();
        return;
      }

      const sections = getThemeSectionsToRender();
      const body = {
        items: [
          {
            id: Number(variantId),
            quantity: 1,
            properties: {
              [PROPERTY_NAME]: PROPERTY_VALUE
            }
          }
        ]
      };

      if (sections.length) {
        body.sections = sections;
        body.sections_url = window.location.pathname;
      }

      const addResponse = await fetchJson(buildCartUrl('cart/add.js'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(body)
      });

      const updatedCart = await getCart();

      closeModal();
      renderThemeCart(addResponse, updatedCart);
      updateProgressBars(updatedCart);
      scheduleCartCheck();
      document.dispatchEvent(new CustomEvent('free-gift:added', {
        bubbles: true,
        detail: {
          cart: updatedCart,
          sections: addResponse.sections || {}
        }
      }));
      document.dispatchEvent(new CustomEvent('cart:updated', {
        bubbles: true,
        detail: updatedCart
      }));
    } catch (error) {
      console.error('[free-gift] Could not add gift.', error);
    } finally {
      modal.classList.remove('is-loading');
      isMutatingGift = false;
    }
  }

  async function checkCartState() {
    if (isChecking || isMutatingGift) return;

    isChecking = true;

    try {
      let cart = await getCart();
      const subtotal = eligibleSubtotal(cart);

      if (subtotal < getActiveThreshold()) {
        closeModal();
        cart = await removeAllGifts(cart);
        renderThemeCart(cart, cart, { openDrawer: false });
        updateProgressBars(cart);
        document.dispatchEvent(new CustomEvent('free-gift:removed', {
          bubbles: true,
          detail: {
            cart,
            sections: cart.sections || {}
          }
        }));
        document.dispatchEvent(new CustomEvent('cart:updated', {
          bubbles: true,
          detail: cart
        }));
        return;
      }

      cart = await enforceSingleGift(cart);
      updateProgressBars(cart);

      if (!hasGift(cart)) {
        openModal();
      } else {
        closeModal();
      }
    } catch (error) {
      console.error('[free-gift] Could not check cart.', error);
    } finally {
      isChecking = false;
    }
  }

  function scheduleCartCheck(delay) {
    window.clearTimeout(checkTimer);
    checkTimer = window.setTimeout(checkCartState, typeof delay === 'number' ? delay : CHECK_DELAY);
  }

  function isCartObject(value) {
    return value && Array.isArray(value.items);
  }

  function normalizeProgressFromCart(cart) {
    if (!isCartObject(cart)) return;

    lastKnownCart = cart;
    window.requestAnimationFrame(() => {
      updateProgressBars(cart);
    });
  }

  function isCartMutationUrl(url) {
    if (!url) return false;

    const stringUrl = typeof url === 'string' ? url : url.url;
    if (!stringUrl) return false;

    return CART_ENDPOINTS.some((endpoint) => stringUrl.includes(endpoint));
  }

  function patchFetch() {
    if (!window.fetch || window.fetch.__freeGiftPatched) return;

    const originalFetch = window.fetch;

    window.fetch = function patchedFetch(input, init) {
      if (isCartMutationUrl(input)) {
        captureCurrentProgressPercent();
      }

      const promise = originalFetch.apply(this, arguments);

      if (isCartMutationUrl(input)) {
        promise
          .then((response) => {
            if (!response || typeof response.clone !== 'function') return;

            response.clone().json()
              .then(normalizeProgressFromCart)
              .catch(() => {});
          })
          .catch(() => {});

        promise.finally(scheduleCartCheck);
      }

      return promise;
    };

    window.fetch.__freeGiftPatched = true;
  }

  function patchXhr() {
    if (!window.XMLHttpRequest || window.XMLHttpRequest.__freeGiftPatched) return;

    const originalOpen = window.XMLHttpRequest.prototype.open;
    const originalSend = window.XMLHttpRequest.prototype.send;

    window.XMLHttpRequest.prototype.open = function patchedOpen(method, url) {
      this.__freeGiftUrl = url;
      return originalOpen.apply(this, arguments);
    };

    window.XMLHttpRequest.prototype.send = function patchedSend() {
      if (isCartMutationUrl(this.__freeGiftUrl)) {
        captureCurrentProgressPercent();
        this.addEventListener('loadend', () => {
          try {
            normalizeProgressFromCart(JSON.parse(this.responseText));
          } catch (error) {
            // The cart endpoint can return non-cart payloads, for example cart/add.
          }

          scheduleCartCheck();
        });
      }

      return originalSend.apply(this, arguments);
    };

    window.XMLHttpRequest.__freeGiftPatched = true;
  }

  function observeProgressRenders() {
    if (!window.MutationObserver || !document.body) return;

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            const hasProgress = (node.matches && node.matches(SELECTORS.progress)) ||
              (node.querySelector && node.querySelector(SELECTORS.progress));

            if (hasProgress) {
              if (lastKnownCart) {
                updateProgressBars(lastKnownCart);
              }
              scheduleCartCheck(0);
            }
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function bindEvents() {
    modal.addEventListener('change', (event) => {
      if (event.target.matches(SELECTORS.variant)) {
        const item = event.target.closest(SELECTORS.item);

        if (item && item.classList.contains('is-selected')) {
          selectedVariantId = event.target.value;
        }
      }
    });

    modal.addEventListener('click', (event) => {
      if (event.target.closest(SELECTORS.close)) {
        closeModal();
        return;
      }

      const pickButton = event.target.closest(SELECTORS.pick);
      if (pickButton) {
        const item = pickButton.closest(SELECTORS.item);
        selectGiftItem(item);
        return;
      }

      const claimButton = event.target.closest(SELECTORS.claim);
      if (claimButton && !claimButton.disabled) {
        addGift(selectedVariantId);
      }
    });

    document.addEventListener('submit', (event) => {
      const form = event.target;

      if (form && form.matches && form.matches(SELECTORS.cartForm)) {
        scheduleCartCheck();
      }
    }, true);

    document.addEventListener('click', (event) => {
      const toggle = event.target.closest(SELECTORS.progressToggle);
      if (toggle) {
        toggleProductProgress(toggle.closest(SELECTORS.productProgress));
        return;
      }

      if (event.target.closest(SELECTORS.progressClaim)) {
        openModal();
      }
    });

    document.addEventListener('cart:updated', scheduleCartCheck);
    document.addEventListener('cart:change', scheduleCartCheck);
    document.addEventListener('cart:refresh', scheduleCartCheck);
    document.addEventListener('ajaxProduct:added', scheduleCartCheck);
    document.addEventListener('product:added', scheduleCartCheck);

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !modal.hidden) {
        closeModal();
      }
    });

    window.addEventListener('resize', updateProductProgressOffset);
  }

  patchFetch();
  patchXhr();
  observeProgressRenders();
  bindEvents();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      updateProductProgressOffset();
      checkCartState();
    }, { once: true });
  } else {
    updateProductProgressOffset();
    checkCartState();
  }
})();
